export interface ConfigAuth {
  oauth2Clients: IOAuth2Clients[];
  sessionTimeout: number;
}

export interface IOAuth2Clients {
  clientId: string;
  url: string;
}


export enum OAUTH_CLIENTS {
  superset = 'inspark-superset'
}
